import { render } from "./LeftBarMenu.vue?vue&type=template&id=4c8d21cd&ts=true"
import script from "./LeftBarMenu.vue?vue&type=script&lang=ts"
export * from "./LeftBarMenu.vue?vue&type=script&lang=ts"

import "./LeftBarMenu.vue?vue&type=style&index=0&id=4c8d21cd&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__